<template>
  <div :style="{ 'paddingBottom': pagination.pages > 1 ? '70px' : '50px' }">
    <app-cells><h1 class="title">Payments</h1></app-cells>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <div class="sticky-title sticky-title--gray">Waiting confirmation</div>
      <div v-if="!items_payments.length" class="no-results">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">You dont have any pending payments</div>
      </div>
      <div v-else class="info-cards info-cards--mb20">
        <div
          v-for="item of items_payments"
          :key="item.id"
          class="info-cards__card"
        >
          <span class="info-cards__row"><span>Payment ID:</span><span>{{ item.id }}</span></span>
          <span class="info-cards__row"><span>Group:</span><span>{{ item.client_group?.name || '-' }}</span></span>
          <span class="info-cards__row"><span>Date:</span><span>{{ dateTimeFormat(item.created_at) }}</span></span>
          <span class="info-cards__row" v-if="item.stats.cash || item.stats.cc_payments">
            <span class="info-cards__row" v-if="item.stats.cash">
              <span>Cash:</span><span>{{ item.stats.cash }}</span>
            </span>
            <span v-if="item.stats.cash && item.stats.cc_payments">/</span>
            <span class="info-cards__row" v-if="item.stats.cc_payments">
              <span>CC :</span><span>{{ item.stats.cc_payments }}</span>
            </span>
          </span>
          <span class="info-cards__row" v-if="item.stats.gears">
            <span>Gear:</span><span>{{ item.stats.gears }}</span>
          </span>
          <span class="info-cards__row" v-if="item.stats.additional_services">
            <span>Additional:</span><span>{{ item.stats.additional_services }}</span>
          </span>
        </div>
      </div>
      <app-cells v-if="pagination.pages > 1" position="center" :indent="false">
        <paginate
          :clickHandler="onClickPagination"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </app-cells>
      <div class="fixed-footer">
        <app-cells position="center">
          <router-link :to="{ name: 'finance-payments-create' }" class="btn btn--default">Post new payment</router-link>
        </app-cells>
      </div>
    </template>
  </div>
</template>

<script>
import { getFinancePaymentsOnSite } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'FinancePayments',
  data() {
    return {
      page_loaded: false,
      items_payments: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getFinancePaymentsOnSite({ page: this.pagination.page, page_size: 5 })
        .then(response => {
          this.items_payments = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.page_loaded = true
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
